import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const PendingSecretary = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);

      
      const statusOptions = [
        // {value: "all" , label:"All"},
          { value: "all_pending", label: "All Applications" , role:["SEC", "INSP","JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY"] },
        { value: "pendingAtApmcSecretary", label: "Pending with APMC Secretary" ,  role:["SEC","INSP","JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY"] },
        { value: "pendingAtInsp", label: "Pending with APMC Inspector" ,  role:["INSP","SEC","JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY"] },
        { value: "pendingAtInspResubmission", label: "Pending Resubmission with APMC Inspector" ,  role:["INSP","SEC","JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY"] },

        { value: "pendingAtSecreatryResubmission", label: "Pending Resubmission with APMC Secretary" ,  role:["SEC","INSP","JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY"] },

        // { value: "licenseGranted", label: "Approved Unsigned" },    
        // { value: "clerkAfterApproveAction", label: " Approved Application" }, 
        // { value: "clerkAfterRejectionAction", label: "Rejection Application" }, 
      ];

      const rolePriorityMap: Record<string, string> = {
        SEC: "all_pending",
    
      };
     
      const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));

      const firstOptionValue = rolePriorityMap[roleIdentifier] || filteredOptions[0]?.value;
      
      // Reorder the options to place the matched option first
      const reorderedStatusOptions = [
        filteredOptions.find(option => option.value === firstOptionValue),
        ...filteredOptions.filter(option => option.value !== firstOptionValue)
      ].filter(Boolean); 


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={reorderedStatusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default PendingSecretary;
